<template>
  <div>
    <div
      v-if="cs_stateName !== 'trust-review-and-confirm'"
      class="pvd-form-row"
    >
      <div class="form-row-label label-icon">
        <label
          id="checkgroup-label"
          class="pvd-label"
        >
          <a
            id="trust-state-modal-trigger"
            href="javascript:void(0);"
          >
            <pvd-icon
              icon="help"
              class="m-small-left"
            />
          </a>
          Trust is governed by the laws of
        </label>
      </div>
      <pvd-modal
        id="trust-state-modal"
        for="trust-state-modal-trigger"
        class="small"
      >
        <div slot="modal-header">
          <h2 class="pvd-heading-L">
            State laws your trust is governed by
          </h2>
        </div>
        <div slot="modal-body">
          <div class="pvd-container">
            <p>
              Your trust documents set forth the terms of your trust, including the state
              laws that your trust was created under and must abide by.
            </p>
          </div>
        </div>
      </pvd-modal>
      <div class="form-row-content">
        <select
          :id="idPrefix"
          :key="name"
          v-model="mutableTrustState"
          v-validate="{required: true}"
          :class="['pvd-select', {'input-error': errors.has(name)}]"
          :name="name"
          :aria-invalid="errors.has(name) ? true: null"
          :aria-describedby="errors.has(name) ? `${idPrefix}Error` : null"
        >
          <option
            v-for="option in allStatesList"
            :key="option.value"
            :value="option.value"
          >
            {{ option.option }}
          </option>
        </select>
      </div>
      <InlineMessage
        v-show="errors.has(name)"
        :id-prefix="idPrefix"
        message="Select a State."
      />
    </div>
    <div
      v-if="cs_stateName === 'trust-review-and-confirm'"
      class="pvd-display-row"
    >
      <div class="display-row-label label-icon">
        <p>
          Trust is governed by the laws of
        </p>
      </div>
      <div class="display-row-content">
        <p
          :id="idPrefix"
          type="text"
          name="name"
        >
          {{ readonlyTrustState }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import InlineMessage from './InlineMessage.vue';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';
import dataHelper from '../mixins/dataHelper';

export default {
  name: 'SelectStateComponent',
  components: { InlineMessage },
  mixins: [utilityFunctions, validationHelper, dataHelper],
  inject: ['$validator'],
  $_veeValidate: {
    value() {
      return this.mutableTrustState;
    },
    name() {
      return this.name;
    },
  },
  props: {
    trustState: {
      type: String,
      default: '',
    },
    idPrefix: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      allStatesList: [
        {
          option: 'Select one',
          value: '',
        },
        {
          option: 'Alabama',
          value: 'AL',
        },
        {
          option: 'Alaska',
          value: 'AK',
        },
        {
          option: 'Arizona',
          value: 'AZ',
        },
        {
          option: 'Arkansas',
          value: 'AR',
        },
        {
          option: 'California',
          value: 'CA',
        },
        {
          option: 'Colorado',
          value: 'CO',
        },
        {
          option: 'Connecticut',
          value: 'CT',
        },
        {
          option: 'Delaware',
          value: 'DE',
        },
        {
          option: 'District of Columbia',
          value: 'DC',
        },
        {
          option: 'Florida',
          value: 'FL',
        },
        {
          option: 'Georgia',
          value: 'GA',
        },
        {
          option: 'Hawaii',
          value: 'HI',
        },
        {
          option: 'Idaho',
          value: 'ID',
        },
        {
          option: 'Illinois',
          value: 'IL',
        },
        {
          option: 'Indiana',
          value: 'IN',
        },
        {
          option: 'Iowa',
          value: 'IA',
        },
        {
          option: 'Kansas',
          value: 'KS',
        },
        {
          option: 'Kentucky',
          value: 'KY',
        },
        {
          option: 'Louisiana',
          value: 'LA',
        },
        {
          option: 'Maine',
          value: 'ME',
        },
        {
          option: 'Maryland',
          value: 'MD',
        },
        {
          option: 'Massachusetts',
          value: 'MA',
        },
        {
          option: 'Michigan',
          value: 'MI',
        },
        {
          option: 'Minnesota',
          value: 'MN',
        },
        {
          option: 'Mississippi',
          value: 'MS',
        },
        {
          option: 'Missouri',
          value: 'MO',
        },
        {
          option: 'Montana',
          value: 'MT',
        },
        {
          option: 'Nebraska',
          value: 'NE',
        },
        {
          option: 'Nevada',
          value: 'NV',
        },
        {
          option: 'New Hampshire',
          value: 'NH',
        },
        {
          option: 'New Jersey',
          value: 'NJ',
        },
        {
          option: 'New Mexico',
          value: 'NM',
        },
        {
          option: 'New York',
          value: 'NY',
        },
        {
          option: 'North Carolina',
          value: 'NC',
        },
        {
          option: 'North Dakota',
          value: 'ND',
        },
        {
          option: 'Ohio',
          value: 'OH',
        },
        {
          option: 'Oklahoma',
          value: 'OK',
        },
        {
          option: 'Oregon',
          value: 'OR',
        },
        {
          option: 'Pennsylvania',
          value: 'PA',
        },
        {
          option: 'Rhode Island',
          value: 'RI',
        },
        {
          option: 'South Carolina',
          value: 'SC',
        },
        {
          option: 'South Dakota',
          value: 'SD',
        },
        {
          option: 'Tennessee',
          value: 'TN',
        },
        {
          option: 'Texas',
          value: 'TX',
        },
        {
          option: 'Utah',
          value: 'UT',
        },
        {
          option: 'Vermont',
          value: 'VT',
        },
        {
          option: 'Virginia',
          value: 'VA',
        },
        {
          option: 'Washington',
          value: 'WA',
        },
        {
          option: 'West Virginia',
          value: 'WV',
        },
        {
          option: 'Wisconsin',
          value: 'WI',
        },
        {
          option: 'Wyoming',
          value: 'WY',
        },
      ],
    };
  },
  computed: {
    mutableTrustState: {
      get() {
        return this.trustState;
      },
      set(newValue) {
        this.$emit('update:trustState', newValue);
      },
    },

    readonlyTrustState() {
      const data = this.allStatesList.find((item) => item.value === this.trustState);
      return data.option;
    },
  },
};
</script>

<style scoped>

</style>
